module.exports = __webpack_public_path__ + "static/img/jcyy-content-1.a64c4fd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/productService/chartTexeraJc/jcyy-content-1.png
// module id = LGF3
// module chunks = 34